import axios from "axios";

const headers = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  },
});

export const actionUserAdd = async function (data: any) {
  const request = await axios.post(
    `${process.env.REACT_APP_API_URL}/users`,
    data
  );
  return {
    type: "USER_ADD",
    payload: request,
  };
};

export const actionUserAuth = async function (data: any) {
  const request = await axios.post(
    `${process.env.REACT_APP_API_URL}/auth/local`,
    data
  );
  return {
    type: "USER_AUTH",
    payload: request,
  };
};

export const actionUserResetPassword = async function (data: any) {
  const request = await axios.post(
    `${process.env.REACT_APP_API_URL}/auth/reset-password`,
    data
  );
  return {
    type: "USER_RESET",
    payload: request,
  };
};

export const actionUserForgotPassword = async function (data: any) {
  const request = await axios.post(
    `${process.env.REACT_APP_API_URL}/auth/forgot-password`,
    data
  );
  return {
    type: "USER_RESET",
    payload: request,
  };
};

export const actionUserGet = function (id) {
  const request = axios.get(
    `${process.env.REACT_APP_API_URL}/users/${id}`,
    headers()
  );
  return {
    type: "USER_GET",
    payload: request,
  };
};

export const actionMunicipalitiesGet = function () {
  const request = axios.get(
    `${process.env.REACT_APP_API_URL}/municipalities?_limit=100`,
    headers()
  );
  return {
    type: "MUNICIPALITIES_GET",
    payload: request,
  };
};

export const actionUserSignOut = function (data: any) {
  return {
    type: "USER_SIGN_OUT",
    data,
  };
};

export const actionScenarioAdd = function (data: any) {
  const request = axios.post(
    `${process.env.REACT_APP_API_URL}/scenarios`,
    data,
    headers()
  );
  return {
    type: "SCENARIO_ADD",
    payload: request,
  };
};

export const actionScenarioReset = function () {
  return {
    type: "SCENARIO_RESET",
  };
};

export const actionScenarioDelete = function (data: any) {
  const request = axios.delete(
    `${process.env.REACT_APP_API_URL}/scenarios/${data.id}`,
    headers()
  );
  return {
    type: "SCENARIO_DELETE",
    payload: request,
  };
};

export const actionScenarioBlockgroupAdd = function (data: any) {
  return {
    type: "SCENARIO_BLOCKGROUP_ADD",
    data: data,
  };
};

export const actionScenarioParcelAdd = function (data: any) {
  return {
    type: "SCENARIO_PARCEL_ADD",
    data: data,
  };
};

export const actionScenarioTitleEdit = function (data: any) {
  return {
    type: "SCENARIO_TITLE_EDIT",
    data: data,
  };
};

export const actionScenarioGeometryDelete = function (data: any) {
  return {
    type: "SCENARIO_GEOMETRY_DELETE",
    data: data,
  };
};

export const actionScenarioSave = function (data: any) {
  const request = axios.put(
    `${process.env.REACT_APP_API_URL}/scenarios/${data.id}`,
    data,
    headers()
  );
  return {
    type: "SCENARIO_SAVE",
    payload: request,
  };
};

export const actionScenarioGet = function (data: any) {
  const request = axios.get(
    `${process.env.REACT_APP_API_URL}/scenarios/${data.id}`
  );
  return {
    type: "SCENARIO_GET",
    payload: request,
  };
};

export const actionAddFeature = function (data: any) {
  return {
    type: "SCENARIO_ADD_FEATURE",
    data: data,
  };
};

export const actionBlockgroupValueEdit = function (data: any) {
  return {
    type: "BLOCKGROUP_VALUE_EDIT",
    data: data,
  };
};

export const actionScenarioCanopyGoalEdit = function (data: any) {
  return {
    type: "SCENARIO_CANOPY_GOAL_EDIT",
    data: data,
  };
};

export const actionBlockgroupSpeciesPropertyEdit = function (data: any) {
  return {
    type: "BLOCKGROUP_SPECIES_PROPERTY_EDIT",
    data: data,
  };
};

export const actionParcelSpeciesPropertyEdit = function (data: any) {
  return {
    type: "PARCEL_SPECIES_PROPERTY_EDIT",
    data: data,
  };
};

export const actionParcelAcresAddedEdit = function (data: any) {
  return {
    type: "PARCEL_ACRES_ADDED_EDIT",
    data: data,
  };
};

export const actionFeatureSpeciesPropertyEdit = function (data: any) {
  return {
    type: "FEATURE_SPECIES_PROPERTY_EDIT",
    data: data,
  };
};

export const actionFeatureAcresAddedEdit = function (data: any) {
  return {
    type: "FEATURE_ACRES_ADDED_EDIT",
    data: data,
  };
};
